import React from 'react';
import './Header.css';
import { LandingMode } from '../../constants/bookingSteps';
import Stepper from '../Stepper/Stepper';

interface HeaderProps {
    currentStep: number;
    visitedSteps: Set<number>;
    onStepClick: (step: number) => void;
    landingMode: LandingMode;
    showRoomInStepper: boolean;
    includeSummaryStep?: boolean;
}

const Header: React.FC<HeaderProps> = ({
    currentStep,
    visitedSteps,
    onStepClick,
    landingMode,
    showRoomInStepper,
    includeSummaryStep = true,
}) => {
    return (
        <header className="header">
            <Stepper
                currentStep={currentStep}
                visitedSteps={visitedSteps}
                onStepClick={onStepClick}
                landingMode={landingMode}
                showRoomInStepper={showRoomInStepper}
                includeSummaryStep={includeSummaryStep}
            />
        </header>
    );
};

export default Header;
